markdownDiagram:
  zoomIn: Vergrössern
markdownImage:
  zoom: Bild vergrössern
  close: Schliessen
search:
  close: Suche schliessen
  tipClose: zum Schliessen
docs:
  closeMenu: Navigationsmenü schliessen
common:
  aria:
    close: Schliessen
    resizePanel: Panelgrösse ändern
  flow:
    zoomIn: Vergrössern
envEditor:
  projectSecretBadKey: «{key}» muss mit einem Grossbuchstaben beginnen und darf nur Grossbuchstaben, Ziffern oder Unterstriche enthalten (maximal 64 Zeichen).
codeEditor:
  expand: Editor vergrössern
  syntax:
    unterminatedTemplate: "Zu diesem '{{' fehlt das schliessende '}}'."
  phrases:
    close: Schliessen
    matchCase: Gross-/Kleinschreibung
valueTree:
  summary:
    quote: '«{text}»'
  elided:
    whole: Zu gross zum Speichern ({size})
dataView:
  closeFullScreen: Vollbild schliessen
flow:
  canvas:
    arrangeFailed: Die Nodes liessen sich nicht anordnen und stehen deshalb untereinander.
